import { UseLocationModalResult, useLocationModal } from "../../hooks/useLocationModal.ts"

export function useMoneyFlowLayoutModal(): UseLocationModalResult {
    return useLocationModal('moneyflow-layout')
}
